import type { AccordionDesignTokens, AccordionTokenSections } from '@openng/optimus-ui-themes/types/accordion';

export const root: AccordionTokenSections.Root = {
    transitionDuration: '{transition.duration}'
};

export const panel: AccordionTokenSections.Panel = {
    borderWidth: '0 0 1px 0',
    borderColor: '{content.border.color}'
};

export const header: AccordionTokenSections.Header = {
    color: '{text.color}',
    hoverColor: '{primary.color}',
    activeColor: '{primary.color}',
    activeHoverColor: '{primary.color}',
    padding: '0.5rem',
    fontWeight: '600',
    borderRadius: '0',
    borderWidth: '1px',
    borderColor: 'transparent',
    background: '{surface.0}',
    hoverBackground: '{primary.50}',
    activeBackground: '{surface.0}',
    activeHoverBackground: '{surface.0}',
    focusRing: {
        width: '{focus.ring.width}',
        style: '{focus.ring.style}',
        color: '{focus.ring.color}',
        offset: '-1px',
        shadow: '{focus.ring.shadow}'
    },
    toggleIcon: {
        color: '{text.color}',
        hoverColor: '{primary.color}',
        activeColor: '{primary.color}',
        activeHoverColor: '{primary.color}'
    },
    first: {
        topBorderRadius: '{content.border.radius}',
        borderWidth: '0'
    },
    last: {
        bottomBorderRadius: '{content.border.radius}',
        activeBottomBorderRadius: '0'
    }
};

export const content: AccordionTokenSections.Content = {
    borderWidth: '0',
    borderColor: '{content.border.color}',
    background: '{content.background}',
    color: '{text.color}',
    padding: '0 1.125rem 1.125rem 1.125rem'
};

export default {
    root,
    panel,
    header,
    content
} satisfies AccordionDesignTokens;
